module.exports = __webpack_public_path__ + "assets/img/2021scan.913f9b43.png";